export const activeButtonShadow = {
  boxShadow: '0 2px 6px hsl(240,0%,70%);',
};

const s = 1;

export const AVATAR_SIZE = 5;
export const POST_IMAGE_H = 10 * s;
export const POST_IMAGE_W = 20 * s;
export const CENTER_BUTTON_SIZE = 5;
export const VOTE_BUTTON_SIZE = 4;
export const SIDE_NAV_PADDING = 3;
export const MAX_POST_WIDTH = 120;

export const DESKTOP_PADDING = 4;

export const BANNER_PROMPT_HEIGHT = [7 * 8, 5 * 8];

export const headerHeight = 10 * 8;
export const sideNavWidth = 37 * 8;

export const NESTING_UNIT = 3;
export const POST_BUTTONS_NESTING_UNITS = 4;
// export const POST_BUTTONS_UNITS = 4;
export const POST_BUTTONS_WIDTH = POST_BUTTONS_NESTING_UNITS * NESTING_UNIT;

export const NESTING_UNIT_RESONSIVE = 2;
export const POST_BUTTONS_WIDTH_RESPONSIVE =
  POST_BUTTONS_NESTING_UNITS * NESTING_UNIT_RESONSIVE;

export const buttonFont = {
  fontSize: 1,
  color: 'white',
  fontFamily: 'HelveticaNeue-Medium',
};

export const button = {
  ...buttonFont,
  background: 'blue',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 7,
  minWidth: [15 * 8, 18 * 8],
  px: 2,
  margin: 0,
};

export const animatedElement = {
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 10000,
  backgroundColor: 'transparent',
};
